module.exports = __webpack_public_path__ + "img/schemeList02Display04.9973e9a2.jpg";